import { createAsyncThunk } from "@reduxjs/toolkit";
import CosplayApi from "api/CosplayApi";

export const fetchCosplay = createAsyncThunk(
  "fetchCosplay",
  ({ companyId, shopId }: { companyId: number; shopId: number }) =>
    CosplayApi.fetchCosplay(companyId, shopId)
);
